import { defaultTo } from "lodash";
import { IModel, Model, ModelRecord } from "@common/models";
import { DateTime } from "luxon";

export interface IClinicIncentiveModel extends IModel {
    clinicIncentiveId: number;
    clinicIncentivePeriodId: number;
    storeId: number;
    targetAOV: number;
    partnerPayout: number;
    storeCode: string;
    dispatchDistrict: string;
    state: string;
    periodName: string;
    startDate: string | null;
    endDate: string | null;
}

export class ClinicIncentiveModel extends Model implements ModelRecord<IClinicIncentiveModel> {
    clinicIncentiveId: number;
    clinicIncentivePeriodId: number;
    storeId: number;
    targetAOV: number;
    partnerPayout: number;
    storeCode: string;
    dispatchDistrict: string;
    state: string;
    periodName: string;
    startDate: DateTime | undefined;
    endDate: DateTime | undefined;

    constructor(params?: IClinicIncentiveModel) {
        super(params);
        this.clinicIncentiveId = defaultTo(params?.clinicIncentiveId, 0);
        this.clinicIncentivePeriodId = defaultTo(params?.clinicIncentivePeriodId, 0);
        this.storeId = defaultTo(params?.storeId, 0);
        this.targetAOV = defaultTo(params?.targetAOV, 0.0);
        this.partnerPayout = defaultTo(params?.partnerPayout, 0.0);
        this.storeCode = defaultTo(params?.storeCode, '');
        this.dispatchDistrict = defaultTo(params?.dispatchDistrict, '');
        this.state = defaultTo(params?.state, '');
        this.periodName = defaultTo(params?.periodName, '');
        this.startDate = (params?.startDate) ? DateTime.fromISO(params?.startDate, { zone: "utc" }) : undefined;
        this.endDate = (params?.endDate) ? DateTime.fromISO(defaultTo(params?.endDate, "2000-01-01"), { zone: "utc" }) : undefined;
    }
}
